export enum PrintSite {
  Weston = 'weston',
  Memphis = 'memphis',
  Irving = 'irving',
}

export const PrintSiteLabels: Record<PrintSite, string> = {
  [PrintSite.Weston]: 'Weston',
  [PrintSite.Memphis]: 'Memphis',
  [PrintSite.Irving]: 'Irving',
};

export const PrintSiteOptions = Object.entries(PrintSiteLabels).map(
  ([value, label]) => ({
    value: value as PrintSite,
    label,
  })
);
